import * as React from 'react';
import { Box, ButtonBase, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { ShoppingCartProductsContext } from '../../contexts/ShoppingCartProductsContext';
import { useContext } from 'react';
import { currency } from '../../components/building_blocks/Currency';
import { layoutSheetTopRadius } from '../../theme/colors';

/* Icons */
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';

const ShoppingCartElement = () => {
  const { totalAmount, totalQuantity } = useContext(ShoppingCartProductsContext);

  const navigate = useNavigate();

  if (totalAmount && window.location.href.indexOf("shopping-cart") === -1) {
    return (
      <Box sx={{ alignItems: 'center', bgcolor: 'surface.card', borderRadius: `${layoutSheetTopRadius} ${layoutSheetTopRadius} 0 0`, bottom: 0, boxShadow: '0px -4px 16px rgba(38, 50, 56, 0.08)', display: 'flex', height: '86px', justifyContent: 'space-between', left: '50%', maxWidth: { xs: '100%', sm: 'calc(900px - 32px)' }, px: 3, position: 'fixed', transform: 'translateX(-50%)', width: { xs: '100%', sm: 'calc(100% - 32px)' }, zIndex: 10}}>
        <Box sx={{ alignItems: 'center', color: 'text.secondary', display: 'flex', flex: 1, gap: 1 }}>
          <LocalGroceryStoreIcon sx={{ fontSize: 24 }} />
          <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', color: 'text.secondary', fontWeight: 700, lineHeight: '24px' }}>
            {totalQuantity} Items
          </Typography>
        </Box>

        <ButtonBase data-no-shadow="true" type="button" onClick={() => { navigate('/shopping-cart'); window.scrollTo(0, 0); }}
          sx={{ color: 'text.primary', display: 'flex', flex: 1, fontFamily: 'Nunito', fontSize: '16px', fontWeight: 700, justifyContent: 'center', lineHeight: '24px'}}>
          Ver carrinho
        </ButtonBase>

        <Typography sx={{ color: 'text.secondary', display: 'flex', flex: 1, fontFamily: 'Nunito', fontSize: '16px', fontWeight: 700, justifyContent: 'flex-end', lineHeight: '24px'}}>
          {currency(totalAmount)}
        </Typography>
      </Box>
    );
  }
};

export default ShoppingCartElement;
